import { withStyles } from "@material-ui/core/styles";
import Slider from "@material-ui/core/Slider";

export const CustomSlider = withStyles(theme => ({
  root: {
    color: theme.kooee.slider.rootColor,
    height: 8,
    padding: "13px 0"
  },
  thumb: {
    height: 27,
    width: 27,
    backgroundColor: theme.kooee.backgrounds.primary,
    color: theme.kooee.backgrounds.other,
    border: "1px solid currentColor",
    marginTop: -9,
    marginLeft: -6,
    boxShadow: "#ebebeb 0px 2px 2px",
    "&:focus,&:hover,&$active": {
      boxShadow: "#ccc 0px 2px 3px 1px"
    },
    "& .bar": {
      height: 9,
      width: 1,
      backgroundColor: "currentColor",
      marginLeft: 1,
      marginRight: 1
    }
  },
  active: {},
  valueLabel: {},
  track: {
    height: 8
  },
  rail: {
    color: theme.kooee.slider.rail,
    opacity: 1,
    height: 8
  },
  mark: {
    backgroundColor: theme.kooee.slider.mark,
    height: 15,
    width: 15,
    borderRadius: "50%",
    top: "28%"
  },
  markLabel: {
    left: "10px"
  }
}))(Slider);
